import React, { useEffect, useState } from 'react';
import { useRive, Layout, Fit, Alignment } from 'rive-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SplashScreen() {
  const navigate = useNavigate();
  const { user, authLoading } = useAuth();
  const [visible, setVisible] = useState(false);
  const [timerDone, setTimerDone] = useState(false);

  const AUTH_PATHS = ['/login', '/register', '/verify-email', '/forgot-password', '/splash', '/auth', '/'];

  // Fade in on first paint
  useEffect(() => { requestAnimationFrame(() => setVisible(true)); }, []);

  // Mark when the minimum splash duration has elapsed.
  useEffect(() => {
    const timer = setTimeout(() => setTimerDone(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Navigate only when BOTH the timer has fired AND auth has finished loading.
  // This prevents the previous bug where a slow Firestore profile fetch
  // (>3 s on no-cache cold start) caused the timer to see authLoading=true,
  // silently abort, and leave the user stuck on the splash screen forever.
  useEffect(() => {
    if (!timerDone || authLoading) return;
    const savedPage = localStorage.getItem('kc_lastPage') ?? '';
    const isSafe = savedPage && !AUTH_PATHS.some(p => savedPage === p || savedPage.startsWith(p + '/'));
    const destination = user ? (isSafe ? savedPage : '/records') : '/login';
    navigate(destination, { replace: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerDone, authLoading, user]);

  const { RiveComponent } = useRive({
    src: '/splash.riv',
    autoplay: true,
    animations: ['Splash'],
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
  });

  return (
    <div className={`fixed inset-0 flex items-center justify-center bg-white overflow-hidden transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0'}`}>
      <div style={{ width: 'min(100vw, 100vh)', height: 'min(100vw, 100vh)', flexShrink: 0 }}>
        <RiveComponent style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  );
}
